<template>
  <div
    class="icon"
    :class="{ 'sing-up-ing': status == '1', 'sing-up-end': status == '0' }"
  >
    <span>{{ name }}</span>
  </div>
</template>

<script>
export default {
  props: {
    name: {
      type: String,
      default: ''
    },
    status: {
      type: Number,
      default: 0
    }
  }
};
</script>

<style lang="scss" scoped>
.icon {
  width: 120px;
  height: 40px;
  text-align: right;
  padding-right: 16px;
  line-height: 1.2;
  span {
    font-size: 22px;
    color: #fff;
    text-align: center;
  }
}
.sing-up-ing {
  background: url('../../../common/images/visa-change/gold-icon.png') no-repeat
    center;
  background-size: 100% 40px;
}
.sing-up-end {
  background: url('../../../common/images/visa-change/gray-icon.png') no-repeat
    center;
  background-size: 100% 40px;
}
</style>
